export default __webpack_public_path__ + "static/media/Varsun_Home.1dc7470f.png";